"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHand(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm5.082 10.22071c-.08254.22-4.35559-3.73387-5.05827-1.58321-.15523.47507.458.18037 1.6529 1.2826a14.5 14.5 0 0 1 1.7923 2.60528c.80186 1.14783 3.94186 5.07278 8.22028 2.75558 0 0 1.89815-1.12728 2.08544-5.81177.019-.47527 1.21369-5.44744 1.21369-5.44744s.1381-1.01566-.5354-1.21015a1.14319 1.14319 0 0 0 -1.28986.78559c-.01045.013-.8605 4.11614-.88938 4.21153s-.22214.20742-.21707-.08417c.00777-.44.22444-5.45535.22444-5.45535s.10343-1.18951-.59267-1.2702c-.68536-.07956-.8611.43388-.99055.91486s-.42816 4.88229-.42816 5.10033-.38833.511-.4182-.07014-.11949-5.85364-.11949-5.85364 0-1.09041-1.00189-1.09041a1.04851 1.04851 0 0 0 -.89994 1.07277s.10953 5.55706.10953 5.711c0 .30121-.4182.6413-.59743.09018s-.77587-4.54295-.77587-4.54295c-.11441-.43307-.53609-.97537-.98258-.92978-.45514.04639-.71761.6401-.68107 1.194 0 0 .61 5.496.61735 5.78171a4.30607 4.30607 0 0 1 -.4381 1.84378z' })));
}
exports.default = SvgHand;
